import MissingProductError from "../../errors/MissingProductError";
import MissingVariantError from "../../errors/MissingVariantError";
import MissingDiamondError from "../../errors/MissingDiamondError";
import { jsonApi } from "@spree/storefront-api-v2-sdk";
import normalizeProduct from "./normalize-product";
const normalizeWishlist = (spreeSuccessResponse, spreeWishlist)=>{
    const spreeWishedItems = jsonApi.findRelationshipDocuments(spreeSuccessResponse, spreeWishlist, "wished_items");
    const items = spreeWishedItems.map((spreeWishedItem)=>{
        let productAttr;
        let variantAttr;
        let diamondAttr;
        try {
            const spreeWishedVariant = jsonApi.findSingleRelationshipDocument(spreeSuccessResponse, spreeWishedItem, "variant");
            if (spreeWishedVariant === null) {
                throw new MissingVariantError(`Couldn't find variant for wished item with id ${spreeWishedItem.id}.`);
            }
            const spreeWishedProduct = jsonApi.findSingleRelationshipDocument(spreeSuccessResponse, spreeWishedVariant, "product");
            if (spreeWishedProduct === null) {
                throw new MissingProductError(`Couldn't find product for variant with id ${spreeWishedVariant.id}.`);
            }
            variantAttr = spreeWishedVariant;
            productAttr = spreeWishedProduct;
        } catch (error) {
            variantAttr = null;
            productAttr = null;
        }
        try {
            const spreeWishedDiamond = jsonApi.findSingleRelationshipDocument(spreeSuccessResponse, spreeWishedItem, "diamond");
            if (spreeWishedDiamond === null) {
                throw new MissingDiamondError(`Couldn't find diamond for wished item with id ${spreeWishedItem.id}.`);
            }
            diamondAttr = spreeWishedDiamond;
        } catch (error1) {
            diamondAttr = null;
        }
        const product = productAttr ? normalizeProduct(spreeSuccessResponse, productAttr) : null;
        const variant = product && variantAttr ? product.variants.find((variant)=>{
            return variant.id.toString() === (variantAttr == null ? void 0 : variantAttr.id);
        }) : null;
        let totalPrice = 0;
        if (variantAttr && diamondAttr) {
            totalPrice = Number(variantAttr.attributes.price) + Number(diamondAttr.attributes.price);
        } else if (variantAttr && !diamondAttr) {
            totalPrice = Number(variantAttr.attributes.price);
        } else if (diamondAttr && !variantAttr) {
            totalPrice = Number(diamondAttr.attributes.price);
        }
        return {
            id: spreeWishedItem.id,
            product_id: productAttr ? parseInt(productAttr.id, 10) : null,
            variant_id: variantAttr ? parseInt(variantAttr.id, 10) : null,
            diamond_id: diamondAttr ? parseInt(diamondAttr.id, 10) : null,
            product: product,
            variant: variant,
            diamond: diamondAttr ? diamondAttr.attributes : null,
            totalPrice: totalPrice
        };
    });
    return {
        id: spreeWishlist.id,
        token: spreeWishlist.attributes.token,
        items
    };
};
export default normalizeWishlist;
